import comp from "./PreviewSkeleton";
export default comp;
